export class Shape {
  id: number;

  icon: string = '';
  picture: string = '';

  nameFr: string;
  nameEn: string;

  isFree: boolean;

  sidesCount: number = 0;
  sides: string[] = [];
}
